import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';

/**
 * Hook used to focus the first input field if there is an error
 *
 * @param methods
 */
export const useFocusFirstError = (methods: UseFormReturn<any, any>) => {
  useEffect(() => {
    const checkIsErrorObject = val => !!val?.type;
    const recursiveObject = (val: string) => {
      const obj = methods.formState.errors[val] as object;
      const objKey = Object.keys(obj).find((field: any, x) => {
        return !!methods.formState.errors[val]?.[field];
      });
      return `${val}.${objKey}`;
    };
    const firstError = Object.keys(methods.formState.errors).map(
      (field: any, i: number) => {
        if (checkIsErrorObject(methods.formState.errors[field])) {
          return !!methods.formState.errors[field] && field;
        } else {
          return recursiveObject(field);
        }
      }
    );
    const errorToFocus = Array.isArray(firstError) ? firstError[0] : firstError;
    if (errorToFocus) {
      methods.setFocus(errorToFocus);
      document.querySelector(`[name="${errorToFocus}"`)?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  }, [Object.keys(methods.formState.errors).length, methods.setFocus]); //eslint-disable-line
};
